import {Store,Module,ActionContext} from 'vuex' 
interface PurchaseState{
    cancel:Boolean
}
class PurchaseStore implements Module<PurchaseState,any>{
    namespaced=true;
    state={
        cancel: false,
    }
    actions={
        setCancelData(context:ActionContext<PurchaseState,any>,payload:any){
            context.commit('setCancel',payload.data)
        },
    }
    mutations={
        setCancel(state:PurchaseState,payload:any){
            state.cancel=payload;
        },
    }
}
const purchase=new PurchaseStore();
export default purchase;